import React from "react";
import { Box } from "@mui/material";
import Footer from "../../compnents/common/Footer";

const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", // This ensures the container is at least the full viewport height
        width: "100%",
      }}
    >
      <Box sx={{ flex: "1" }}>{children}</Box>
      <Footer />
    </Box>
  );
};

export default Layout;
